const schedule = [
  {
    day: "Monday",
    checked: false,
    timeSlots: [{ from: "9:30", to: "13:00" }],
  },
  {
    day: "Tuesday",
    checked: false,
    timeSlots: [{ from: "9:30", to: "13:00" }],
  },
  {
    day: "Wednesday",
    checked: false,
    timeSlots: [{ from: "9:30", to: "13:00" }],
  },
  {
    day: "Thursday",
    checked: false,
    timeSlots: [{ from: "9:30", to: "13:00" }],
  },
  {
    day: "Friday",
    checked: false,
    timeSlots: [{ from: "9:30", to: "13:00" }],
  },
  {
    day: "Saturday",
    checked: false,
    timeSlots: [{ from: "9:30", to: "13:00" }],
  },
  {
    day: "Sunday",
    checked: false,
    timeSlots: [{ from: "9:30", to: "13:00" }],
  },
];

export default schedule;


